export const prefersReducedMotion = () => {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};

export const shouldSkipProcessingDelay = () => prefersReducedMotion() || process.env.NODE_ENV === "test";

export const SAMPLE_PROCESS_PHRASES = [
  "Reading the sample roster",
  "Recognizing passengers",
  "Opening a private workspace",
];

export const UPLOAD_PROCESS_PHRASES = [
  "Reading the spreadsheet",
  "Finding passengers",
  "Matching names and phones",
  "Collecting addresses",
  "Preparing findings",
];

export const SAMPLE_PROCESS_STEPS = SAMPLE_PROCESS_PHRASES.map((label) => ({ label, detail: "" }));
export const UPLOAD_PROCESS_STEPS = UPLOAD_PROCESS_PHRASES.map((label) => ({ label, detail: "" }));

export const sampleProcessScript = () => ({
  title: "Preparing the sample roster",
  eyebrow: "Sample roster",
  phrases: SAMPLE_PROCESS_PHRASES,
  footnote: "85 students across three schools are written into a private workspace of your own — real students, real services.",
});

export const uploadProcessScript = (fileName) => ({
  title: "Working on your file",
  eyebrow: fileName || "Your file",
  phrases: UPLOAD_PROCESS_PHRASES,
  footnote: "Nothing is written to your operation until you confirm.",
});

export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
